import {
    OFFERPAGE_RECEIVE,
    OFFERPAGE_SET_DATE,
    OFFERPAGE_SET_LIST
} from '../ConstantsBrafab/constants';

const defaultState = {
    payload: {
        listId: null,
        selectedFavouriteList: null,
        generalDiscount: '',
        currencies: [],
        offerCurrency: {},
        offerDate: {},
        listName: '',
        variantList: [],
        hasStoreRole: false,
        personsInSameOrg: [],
        favouriteListVariants: [],
        isLoggedIn: false,
        title: '',
        discountPrice: '',
        discountPercentage: ''
    },
    result: {},
    isSubmitting: false,
}

export const offerPage = (state = defaultState, action) => {
    switch (action.type) {
        case OFFERPAGE_SET_DATE:
        case OFFERPAGE_SET_LIST:
        case OFFERPAGE_RECEIVE:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}